import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import { Modal, Input } from 'antd';
import './messageSalary.css';
import PropTypes from 'prop-types';

import asReviewWpaFormConfim from '../../public/img/std/asReviewWpaFormConfim.png'
import cancelImg from '../../public/img/newMain/cancel.png';

/**
 * 消息提示组件
 * props传参如下
 * 消息提示类型,样式 ['error','success','warning','info']
 *                              error:错误提示框，红色样式
 *                              success:成功提示框，绿色样式
 *                              warning:警告提示框，黄色样式
 *                              info:普通提示框，蓝色样式
 */
let MessageSalary = (props, ref) => {

    const [content, setContent] = useState("");
    const [isShow, setIsShow] = useState(false);
    const [hkd, setHkd] = useState("");

    useImperativeHandle(ref, () => {
        return {
            setContent,
            setIsShow,
            setHkd
        }
    });

    /**
     * 标题默认值处理
     */
    useEffect(() => {

    }, []);

    const save = ()=>{
        props.done("save", hkd);
    }

    const save2 = ()=>{
        props.done("cancel");
    }

    return (
        <Modal
            open={isShow}
            onCancel={null}
            closeIcon={null}
            footer={null}
            className='messageSalary'
            width={735}
            centered
            closable={false}
        >
            <div className='contentBox'>
                <div>{"If you would like to (optionally) provide any additional comments regarding the offer, such as contact information / instruction, start date, salary details, or any other relevant information, please enter them in the designated box below."}</div>
                <div>{"Your comment will be visible to both the student and the module convener."}</div>
            </div>
            <Input.TextArea placeholder="" className="textArea" maxLength={500} rows={3} value={hkd} onChange={(e) => setHkd(e.target.value)}/>
            <div className='contentBox'>
                <div>Confirm to make offer?</div>
            </div>
            <div className='butArea'>
                <div className='saveButton' onClick={save}><img src={asReviewWpaFormConfim} />Confirm</div>
                <div className='cancelButton' onClick={save2}><img src={cancelImg} />Cancel</div>
            </div>
        </Modal>
    )

}

MessageSalary = forwardRef(MessageSalary);

MessageSalary.propTypes = {
    done: PropTypes.func.isRequired,
};

export default MessageSalary;